:host {
  display: inline-block;
  height: 1em;
  vertical-align: -0.1875em;
  stroke-width: 1.5;
}

svg {
  display: block;
  height: 100%;
  width: auto;
  aspect-ratio: 1 / 1;
  stroke-width: inherit;
}
